import { ShellApp } from 'vrlcm-gui-types';
import * as Constants from '../constants/action-constants';

export interface RequestApps {
  type: Constants.REQUEST_APPS;
}

export interface RequestAppsSuccess {
  type: Constants.REQUEST_APPS_SUCCESS;
  payload: {
    apps: ShellApp[];
  };
}

export interface RequestAppsFailed {
  type: Constants.REQUEST_APPS_FAILED;
}

export type DashboardAction =
  | RequestApps
  | RequestAppsSuccess
  | RequestAppsFailed;

export const requestApps = (): RequestApps => ({
  type: Constants.REQUEST_APPS
});

export const requestAppsSuccess = (apps: ShellApp[]): RequestAppsSuccess => ({
  payload: { apps },
  type: Constants.REQUEST_APPS_SUCCESS
});

export const requestAppsFailed = (): RequestAppsFailed => ({
  type: Constants.REQUEST_APPS_FAILED
});
